import {
    useQuery
} from '@tanstack/react-query';
import * as dataService from './data-service';

export enum QueryKeys {
    messages = 'messsages',
    allConversations = 'allConversations',
    conversation = 'conversation',
    searchEnabled = 'searchEnabled',
    user = 'user',
    endpoints = 'endpoints',
    presets = 'presets',
    searchResults = 'searchResults',
    tokenCount = 'tokenCount'
}

export const useGetConversationsQuery = (
  pageNumber: string
) => {
  return dataService.getConversations(pageNumber);
};